module.exports = __webpack_public_path__ + "static/media/NARATAMA LOGO FIX1.deea6fe2.png";